"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parserFunctionCallExpression = void 0;
const util_1 = require("../util");
const parserFunctionCallExpression = (BaseClass) => {
    const DerivedClass = class extends BaseClass {
        visitFunctionCall(ctx) {
            return {
                type: 'CallExpression',
                callee: (0, util_1.tokenToIdentifierWrapper)(ctx._func),
                arguments: this.visit(ctx._args)
            };
        }
        visitFunctionCallParameters(ctx) {
            if (ctx.expressionList() == undefined) {
                return [];
            }
            // only one child
            const seqeuenceExpressions = this.visit(ctx.getChild(0));
            return seqeuenceExpressions.expressions;
        }
    };
    return DerivedClass;
};
exports.parserFunctionCallExpression = parserFunctionCallExpression;
//# sourceMappingURL=functionCallParser.js.map